import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/styles'
import { useMutation } from '@apollo/client'
import { MC_VEHICLE } from 'graphql/mutations'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import TextField from '@material-ui/core/TextField'
import { TabPanel, allyProps } from './Functions'
import useMediaPath from 'hooks/useMediaPath'
import MenuItem from '@material-ui/core/MenuItem'
import { Dialog } from '@material-ui/core'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import { useQuery } from '@apollo/client'
import {
  Q_HEX_COLORS,
  Q_HEX_COLOR,
  Q_COUNTRIES,
  Q_VEHICLE_TYPES,
  Q_MFT_MODELS,
  Q_MANUFACTURER,
} from 'graphql/query'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import styles from '../vehicle.module.scss'
import PreviewComponent from 'components/Global/Preview'

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}))
const ColorSwatch = ({ id }) => {
  const { refetch } = useQuery(Q_HEX_COLOR, {
    variables: {
      id,
    },
  })
  const [color, setColor] = useState('')

  useEffect(() => {
    refetch() &&
      refetch().then(res => {
        setColor(res.data.rHexColor[0].hex)
      })
  }, [])
  return (
    <div
      className={styles.colorSwatch}
      style={{ backgroundColor: `#${color}` }}
    ></div>
  )
}
const InteriorColor = ({ setInterioColors, colors }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        variant="contained"
        className={styles.colorSelect}
        onClick={() => setOpen(true)}
      >
        Interior Color
      </Button>
      {open && (
        <ColorDialog
          title={'Select Interior Color'}
          open={open}
          handleClose={() => setOpen(false)}
          submit={setInterioColors}
          selectedColors={colors}
        />
      )}
    </>
  )
}
const BodyColor = ({ setBodyColors, colors }) => {
  const [open, setOpen] = useState(false)

  return (
    <div>
      <Button
        variant="contained"
        className={styles.colorSelect}
        onClick={() => setOpen(true)}
      >
        Body Color
      </Button>
      {open && (
        <ColorDialog
          title={'Select Body Color'}
          open={open}
          handleClose={() => setOpen(false)}
          submit={setBodyColors}
          selectedColors={colors}
        />
      )}
    </div>
  )
}
const ColorDialog = ({ open, submit, handleClose, title, selectedColors }) => {
  const [colors, setColors] = useState([])
  const [active, setActive] = useState([])

  const { refetch } = useQuery(Q_HEX_COLORS)
  const handleClick = id => {
    if (!active.includes(id) && active.length < 3) {
      setActive(active => {
        const newArray = [...active, id]
        return newArray
      })
    } else {
      setActive(arr => {
        const newArray = arr.filter(x => x !== id)
        return newArray
      })
    }
  }

  useEffect(() => {
    refetch() &&
      refetch().then(res => {
        setColors(res.data.rHexColor)
      })
    console.log('running')
  }, [])

  return (
    <Dialog
      open={open}
      onClose={() => {
        setActive(selectedColors)
        handleClose()
      }}
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle id="simple-dialog-title">{title}</DialogTitle>{' '}
      <div className={styles.content}>
        {colors.map((color, i) => (
          <PreviewComponent
            preview={`#${color.hex}`}
            componentType="icon"
            previewSize={[80, 80]}
            iconCardWidth={200}
            title={color.name}
          />
        ))}
      </div>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            submit(active)
            handleClose()
          }}
        >
          select
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const VehicleCreateForm = ({ setCreate, update, loading }) => {
  const classes = useStyles()

  const [vMnContent, setVMnContent] = useState(0)
  const [vMnLogo, setVMnLogo] = useState()
  const [vMnName, setVMnName] = useState('')
  const [vMnCode, setVMnCode] = useState('')
  const [vMnDetail, setVMnDetail] = useState('')
  const [vMnId, setVMnId] = useState()
  const [manufacturers, setManufacturers] = useState([])

  const [vehicleTypes, setVehicleTypes] = useState([])
  const [vehicleModels, setVehicleModels] = useState([])
  const [vMdContent, setVMdContent] = useState(0)
  const [vMdId, setVMdId] = useState(0)
  const [vMdTypeId, setVMdTypeId] = useState(0)
  const [vMdName, setVMdName] = useState('')
  const [vMdImage, setVMdImage] = useState('')
  const [vMdCountry, setVMdCountry] = useState('')
  const [vMdCode, setVMdCode] = useState('')
  const [countries, setCountries] = useState([])
  const [open, setOpen] = useState(false)

  const [vMdImAltText, setVMdImAltText] = useState('')

  // const [sdmMdType, setSdmMdType] = useState()
  const [sdmzFile, setSdmzFile] = useState()
  // const [sdmMdThumb, setSdmMdTthumb] = useState()
  const [vvrInteriorColor, setVvrInteriorColor] = useState([])
  const [vvrBodyColor, setVvrBodyColor] = useState([])

  const mediaPath = useMediaPath()

  const [call] = useMutation(MC_VEHICLE)
  const getCountries = useQuery(Q_COUNTRIES).refetch
  const getVehicleTypes = useQuery(Q_VEHICLE_TYPES).refetch
  const getManufacturers = useQuery(Q_MANUFACTURER).refetch
  const getVehicleModels = useQuery(Q_MFT_MODELS, {
    variables: {
      id: parseInt(vMnId),
    },
  }).refetch
  const handleSubmit = () => {
    loading(true)
    call({
      variables: {
        vMnContent: Boolean(vMnContent),
        vMdTypeId,
        vMdContent: Boolean(vMdContent),
        sdmzFile,
        vMnId: parseInt(vMnId),
        vMnLogo,
        vMnName,
        vMnCode,
        vMnDetail,
        vMdId,
        vMdName,
        vMdImage,
        vMdCountry,
        vMdCode,
        vMdImAltText,
        vvrIntColor: vvrInteriorColor,
        vvrBdyColor: vvrBodyColor,
      },
    }).then(res => {
      setCreate(false)
      update()
      console.log(res)
    })
  }

  useEffect(() => {
    getCountries() &&
      getCountries().then(res => {
        setCountries(res.data.rCountries)
      })
  }, [])

  useEffect(() => {
    getVehicleTypes() &&
      getVehicleTypes().then(res => {
        setVehicleTypes(res.data.rVehicleType)
      })
  }, [])

  useEffect(() => {
    if (vMnContent === 1) {
      getManufacturers() &&
        getManufacturers().then(res => {
          setManufacturers(res.data.rManufacturer)
        })
    }
  }, [vMnContent])
  useEffect(() => {
    if (vMdContent === 1 && vMnId) {
      getVehicleModels() &&
        getVehicleModels().then(res => {
          setVehicleModels(res.data.rManufacturer[0].vehiclemodelSet)
        })
    }
  }, [vMdContent, vMnId])

  return (
    <div className={styles.vcfRoot}>
      <div className={styles.vcfRoot}>
        <AppBar position="static" color="default" className={styles.appBar}>
          <Tabs
            value={vMnContent}
            onChange={(event, newValue) => {
              setVMnContent(newValue)
            }}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
          >
            <Tab label="Create Manufactuerer" {...allyProps(0)} />
            <Tab label="select Manufacturer" {...allyProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={vMnContent} index={0}>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            value={vMnName}
            onChange={e => setVMnName(e.target.value)}
            fullWidth
          />{' '}
          <Button
            margin="dense"
            id="logo"
            label="Logo"
            type="file"
            accept=".svg"
            variant="contained"
            component="label"
            className={styles.submit}
          >
            'upload logo'
            <input
              type="file"
              onChange={e => {
                setVMnLogo(e.target.files.item(0))
              }}
              accept=".svg"
            />
          </Button>
          <TextField
            margin="dense"
            id="detail"
            label="Detail"
            type="text"
            fullWidth
            value={vMnDetail}
            onChange={e => setVMnDetail(e.target.value)}
          />{' '}
          <TextField
            margin="dense"
            id="code"
            label="Code"
            type="text"
            fullWidth
            value={vMnCode}
            onChange={e => setVMnCode(e.target.value)}
            inputProps={{ maxLength: 3 }}
          />
        </TabPanel>
        <TabPanel value={vMnContent} index={1}>
          <div className={styles.mfts}>
            {manufacturers.map(mft => (
              <PreviewComponent
                key={mft.id}
                title={mft.name}
                details={mft.details}
                onClickFn={() => {
                  setVMnId(mft.id)
                }}
                preview={mediaPath(mft.logo)}
              ></PreviewComponent>
            ))}
          </div>
        </TabPanel>
      </div>
      <div className={styles.modelRoot}>
        <AppBar position="static" color="default" className={styles.appBar}>
          <Tabs
            value={vMdContent}
            onChange={(event, newValue) => {
              setVMdContent(newValue)
            }}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
          >
            <Tab label="Create Vehicle Model" {...allyProps(0)} />
            <Tab label="select Vehicle Model" {...allyProps(1)} />
          </Tabs>
        </AppBar>
        <TabPanel value={vMdContent} index={0}>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="Set Vehicle Type">Vehicle Type</InputLabel>
            <Select
              value={vMdTypeId}
              onChange={event => {
                setVMdTypeId(parseInt(event.target.value))
              }}
            >
              {vehicleTypes.map((type, i) => {
                return (
                  <MenuItem value={type.id} key={i}>
                    {type.vehicleType}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="age-native-simple">Country</InputLabel>
            <Select
              value={vMdCountry}
              onChange={event => setVMdCountry(event.target.value)}
            >
              {countries.map((country, i) => (
                <MenuItem value={country.key} key={country.key}>
                  <span className={styles.countryWrapper}>
                    <img
                      src={country.flag}
                      width="50px "
                      alt="flag"
                      className={styles.flag}
                    />
                    {country.name}
                  </span>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            margin="dense"
            id="name"
            label="Name"
            type="text"
            value={vMdName}
            onChange={e => setVMdName(e.target.value)}
          />
          <TextField
            margin="dense"
            id="code"
            label="Code"
            type="text"
            value={vMdCode}
            onChange={e => setVMdCode(e.target.value)}
            inputProps={{ maxLength: 3 }}
          />
          <div className={styles.flex}>
            <Button
              margin="dense"
              id="logo"
              label="Logo"
              type="file"
              accept=".svg"
              variant="contained"
              component="label"
              className={styles.submit}
            >
              'upload Model image'
              <input
                type="file"
                onChange={e => {
                  setVMdImage(e.target.files.item(0))
                }}
                accept=".png"
              />
            </Button>
            <TextField
              margin="dense"
              id="alt-text"
              label="Alt-Text"
              type="text"
              value={vMdImAltText}
              onChange={e => setVMdImAltText(e.target.value)}
              className={styles.imgAlt}
            />
          </div>
        </TabPanel>
        <TabPanel value={vMdContent} index={1}>
          <div className={styles.models}>
            {vehicleModels.map(model => (
              <PreviewComponent
                key={model.id}
                title={model.name}
                onClickFn={() => {
                  setVMnId(model.id)
                }}
                preview={mediaPath(model.image.image)}
              ></PreviewComponent>
            ))}
          </div>
        </TabPanel>
      </div>
      <div className={styles.makeRoot}>
        <Button
          autoFocus
          margin="dense"
          id="model"
          label="Model"
          type="file"
          variant="contained"
          component="label"
        >
          upload Model
          <input
            type="file"
            onChange={e => {
              setSdmzFile(e.target.files.item(0))
            }}
            accept=".sdmz"
          />
        </Button>
        <div className={styles.colorSelectWrapper}>
          <div className={styles.colorSelect}>
            <InteriorColor
              setInterioColors={setVvrInteriorColor}
              colors={vvrInteriorColor}
            />
            {vvrInteriorColor.map(id => (
              <ColorSwatch id={id} key={id} />
            ))}
          </div>
          <div className={styles.colorSelect}>
            <BodyColor setBodyColors={setVvrBodyColor} colors={vvrBodyColor} />
            {vvrBodyColor.map(id => (
              <ColorSwatch id={id} key={id} />
            ))}
          </div>
        </div>
      </div>
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleSubmit()}
      >
        Submit
      </Button>
    </div>
  )
}

export default VehicleCreateForm
